import type { Currency, DriverLedgerEntryInput, FinanceEntryKind } from '@chukua/common';
import { parseMoneyAmount } from '../../../shared/policies/parse-money-amount';

export interface LedgerEntryFormValues {
  kind: FinanceEntryKind;
  amount: string;
  currency: Currency;
  note: string;
}

/** Assumes the amount passed `parseMoneyAmount`, which the form's validator guarantees before submit. The key is made once per opening of the drawer so a double click is one entry. */
export function toLedgerEntryInput(values: LedgerEntryFormValues, idempotencyKey: string): DriverLedgerEntryInput {
  const amount = parseMoneyAmount(values.amount, values.currency);
  if (!amount.ok) throw new RangeError(amount.reason);
  return {
    kind: values.kind,
    amount: { amountMinor: amount.amountMinor, currency: values.currency },
    note: values.note.trim(),
    idempotencyKey,
  };
}
